import React, { type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./paragraph.module.scss";

const cx = c.bind(styles);

export const ParagraphVariant = {
  PARAGRAPH100: "paragraph-100",
  PARAGRAPH100MEDIUM: "paragraph-100-medium",
  PARAGRAPH100BOLD: "paragraph-100-bold",
  PARAGRAPH200: "paragraph-200",
  PREAMBLE100: "preamble-100",
  PREAMBLE200: "preamble-200",
  ADDITIONAL100: "additional-100",
  ADDITIONAL100MEDIUM: "additional-100-medium",
  ADDITIONAL100BOLD: "additional-100-bold",
  OVERLINE100: "overline-100",
  OVERLINE200: "overline-200",
} as const;

export type ParagraphVariant = (typeof ParagraphVariant)[keyof typeof ParagraphVariant];

export type ParagraphProps = Omit<BaseProps<"p">, "children"> & {
  children: ReactNode;
  enableHyphenation?: boolean;
  negative?: boolean;
  disabled?: boolean;
  variant?: ParagraphVariant;
};

const rootClassName = "purpur-paragraph";

export const Paragraph = ({
  children,
  className,
  disabled,
  enableHyphenation = false,
  negative = false,
  variant = ParagraphVariant.PARAGRAPH100,
  ...props
}: ParagraphProps) => {
  const classes = cx(rootClassName, `${rootClassName}--${variant}`, {
    [`${rootClassName}--hyphens`]: enableHyphenation,
    [`${rootClassName}--disabled`]: disabled,
    [`${rootClassName}--negative`]: negative,
  }, className);

  return (
    <p {...props} className={classes}>
      {children}
    </p>
  );
};

Paragraph.displayName = "Paragraph";
